function ticketReportColumns(handleEdit, handleDelete, isAdmin) {
  return [
     {
      Header: "Invoice No",
      accessor: "invoice_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Customer Name",
      accessor: "invoice_to",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Mobile No",
      accessor: "mobile",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Vehicle Number",
      accessor: "vehicle_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Date", 
      accessor: "invoice_date",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => {
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getFullYear()).slice(-4); // Get last 2 digits
        return `${day}-${month}-${year}`;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => {
        const serviceMap = {
          1: { text: "UnPaid", class: "bg-warning" },
          2: { text: "Partially Paid", class: "bg-info" },
          3: { text: "Paid", class: "bg-success" },
          4: { text: "Cancelled", class: "bg-secondary" }
        };

        const service = serviceMap[value] || { text: "Unknown", class: "bg-secondary" };

        return (
          <span className={`badge ${service.class}`}>
            {service.text}
          </span>
        );
      },
    },
    {
      Header: "Total",
      accessor: "total",
      disableFilters: true,
      filterable: false,
      Cell: ({ row }) => {
        const { total, paid_amount, status } = row.original;
        const statusNum = Number(status); // Convert status to number

        return (
          <div className="d-flex flex-column">
            {statusNum === 2 && parseFloat(paid_amount) > 0 ? (
              <>
                <div>
                  <span className="fw-bold">Paid: </span>
                  £{parseFloat(paid_amount).toFixed(2)}
                </div>
                <div>
                  <span className="fw-bold">Total: </span>
                  £{parseFloat(total || 0).toFixed(2)}
                </div>
              </>
            ) : (
              <div>£{parseFloat(total || 0).toFixed(2)}</div>
            )}
          </div>
        );
      },
    },
    {
      Header: "Created By",
      accessor: "createdBy.name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Actions",
      accessor: "actions",
      disableFilters: true,
      filterable: false,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          {handleEdit && (
            <button
              onClick={() => handleEdit(row.original)}
              className="btn btn-sm btn-primary"
            >
              View
            </button>
          )}
        </div>
      ),
    },
  ];
}

export default ticketReportColumns;
